import typography from '../typography';

export default palette => ({
  root: {
    ...typography(palette).body1,
    borderBottom: `1px solid ${palette.divider}`,

    '& a': {
      '&:not(.MuiButton-containedPrimary)': {
        color: palette.black,
      },
      '&.action-button': {
        color: palette.greyRegular,
      },

      '&.inactive-link': {
        color: palette.greyLight,
      },

      fontWeight: '700',
    },
    '& .warning-icon': {
      color: palette.warning.main,
    },
  },
});
